module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/1.681ff0b2.png";